export const APP_USER_LOGIN_FORM_INVALID = 'App.User.Login.FormInvalid' // When Form is fcked up
export const APP_USER_LOGIN_FORM_VALIDATION = 'App.User.Login.FormValidation'
export const APP_USER_LOGIN_USER_ALREADY_EXISTS = 'App.User.Login.UserAlreadyExists'
export const APP_USER_LOGIN_USER_NOT_EXISTS = 'App.User.Login.UserNotExists'
export const APP_USER_LOGIN_TOKEN = 'App.User.Login.Token'
export const APP_USER_NAMECHANGE_VALIDATION = 'App.User.NameChange.Validation'
export const APP_USER_CHAT = 'App.User.Chat'

export const APP_ROOM_SETTINGS_VALIDATION = 'App.Room.Settings.Validation'

export const GAME_NOTFOUND = 'Game.NotFound'
export const GAME_PHASE = 'Game.Phase'
export const GAME_QUESTION_NOTFOUND = 'Game.Question.NotFound'
export const GAME_QUESTION_INCORRECT = 'Game.Question.Incorrect'

export const GAME_PLAYER_NOTFOUND = 'Game.Player.NotFound'
export const GAME_PLAYER_TIMEOUT_NOTFOUND = 'Game.Player.Timeout.NotFound'
export const GAME_PLAYER_ACT_NOT_CURRENT_PLAYER = 'Game.Player.Act.NotCurrentPlayer'
export const GAME_PLAYER_ACT_ON_QUESTION = 'Game.Player.Act.OnQuestion'

export const GAME_CARD_NOTFOUND = 'Game.Card.NotFound'
export const GAME_CARD_TRAIT_NOTFOUND = 'Game.Card.Trait.NotFound'

export const GAME_ENTITY_NOTFOUND = 'Game.Entity.NotFound'

export const GAME_LINK_NOTFOUND = 'Game.Link.NotFound'
export const GAME_LINK_SELF = 'Game.Link.Self'

export const GAME_PLANT_NOTFOUND = 'Game.Plant.NotFound'

export const GAME_ANIMAL_NOTFOUND = 'Game.Animal.NotFound'
export const GAME_ANIMAL_NOTAMBUSHER = 'Game.Animal.NotAmbusher'
export const GAME_ANIMAL_POSITION = 'Game.Animal.Position'
export const GAME_ANIMAL_OWNER = 'Game.Animal.Owner'

export const GAME_ANIMAL_FLAG = 'Game.Animal.Flag.NotFound'

export const GAME_ANIMAL_TRAIT_NOTFOUND = 'Game.Animal.Trait.NotFound'

export const GAME_TRAIT_TARGET_TYPE_NOTFOUND = 'Game.Trait.TargetType.NotFound'
export const GAME_TRAIT_TARGET_TYPE_ANIMAL = 'Game.Trait.TargetType'

export const GAME_TRAIT_NOTFOUND = 'Game.Trait.NotFound'
export const GAME_TRAIT_TARGET_ERROR = 'Game.Trait.TargetError'

export const GAME_TRAIT_ACTION_DEFENSE = 'Game.Trait.Action.Defense'
export const GAME_TRAIT_ACTION_SUPRESSED = 'Game.Trait.Action.Supressed'
